import './SellerList.scss';
import Component from './SellerList.js';
export default Component;
